import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "brief-splash__container" }
const _hoisted_2 = { class: "redirection__container" }
const _hoisted_3 = { class: "brief-splash__how-it-works" }
const _hoisted_4 = {
  class: "brief-splash__title",
  "data-testid": "brief-splash-title"
}
const _hoisted_5 = ["innerHTML"]

import {computed, inject, onMounted, onUnmounted, ref} from 'vue';
    import {RouteNames} from '@/brief-hub/router/route-names';
    import {useRouter} from 'vue-router';
    import {Vue3MqResource} from '@/common/types/vue3mq';
    import {useBriefStrategyStore} from '@/brief-hub/stores/briefStrategy.store';
    import {storeToRefs} from 'pinia';
    import {default as briefRegularStore} from '@/brief-hub/store';
    import {MutationsType} from '../store/modules/brief/mutations';
    import {StrategyFreelancerBriefRequest, ExperienceLevel} from '@/common/api/api-raw-types';
    import {useGlobalProperties, useTranslation} from '@malt/vue3-use';
    import {useBriefAmplitudeEvent} from '@/common/composable/useBriefAmplitudeEvent';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'RedirectionStrategyToRegular',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

    const {msg} = useTranslation();

    const emit = __emit;

    const briefStrategyStore = useBriefStrategyStore();
    const {payload, redirectionReason} = storeToRefs(briefStrategyStore);
    const $router = useRouter();
    const {$features} = useGlobalProperties();
    const splash = ref<HTMLInputElement | null>(null);
    const {triggerBriefFunnelStepEnteredAmplitudeEvent} = useBriefAmplitudeEvent();

    const mq: Vue3MqResource | undefined = inject<Vue3MqResource>('mq');

    onMounted(() => {
        splash.value?.focus();
        document.body.style.overflow = 'hidden';
        triggerBriefFunnelStepEnteredAmplitudeEvent('redirection', 2);
    });

    onUnmounted(() => {
        document.body.style.overflow = 'revert';
    });

    const isMobile = computed<boolean>(() => !!mq?.smMinus);

    const redirectionDescription = computed<string>(() => {
        switch (redirectionReason.value) {
            case 'WRONG_JOB_CATEGORY':
                return msg('customer.brief.strategy.redirection.splash-screen.howitworks.description.wrongJobCategory');
            case 'EXPERIENCE_TOO_LOW':
                return msg('customer.brief.strategy.redirection.splash-screen.howitworks.description.experienceTooLow');
            case 'DAILY_RATE_TOO_LOW':
                return msg('customer.brief.strategy.redirection.splash-screen.howitworks.description.dailyRateTooLow');
            default:
                return msg('customer.brief.strategy.redirection.splash-screen.howitworks.description.default');
        }
    });

    function onClose(): void {
        emit('close');
    }

    function mapStrategyExperienceLevelToRegular(experienceLevel: ExperienceLevel) {
        return experienceLevel === ExperienceLevel.EXPERT_PLUS ? ExperienceLevel.EXPERT : experienceLevel;
    }

    function goToNewBrief(): void {
        const redirectionReasonCached = briefStrategyStore.redirectionReason;
        const strategyBriefRequest = payload.value?.payload as StrategyFreelancerBriefRequest;
        const payloadToRegularBrief = {
            jobTitle: strategyBriefRequest?.jobTitle,
            freelancerCategory: strategyBriefRequest?.freelancerCategory,
            experienceLevel: mapStrategyExperienceLevelToRegular(strategyBriefRequest?.experienceLevel),
            freelancerDailyRate: strategyBriefRequest?.dailyFreelancerRate,
        };
        briefRegularStore.commit(MutationsType.PREFILL_STATE_FROM_STRATEGY, payloadToRegularBrief);
        briefStrategyStore.redirectionReason = null;
        $router.push({
            name: RouteNames.BRIEF_NEW,
            query: {
                brief_origin: $router.currentRoute.value.query?.brief_origin,
                redirection_reason: redirectionReasonCached,
            },
        });
    }

    function backToNewStrategy(): void {
        briefStrategyStore.resetStore();
        $router.push({
            name: RouteNames.STRATEGY_BRIEF_NEW,
            query: {
                brief_origin: 'redirection-strategy-to-regular_back-btn',
            },
        });
    }

return (_ctx: any,_cache: any) => {
  const _component_VJoyButton = _resolveComponent("VJoyButton")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!

  return (_openBlock(), _createBlock(_Transition, { name: "slide" }, {
    default: _withCtx(() => [
      _createElementVNode("section", {
        ref_key: "splash",
        ref: splash,
        class: "brief-splash",
        tabindex: "0",
        onKeydown: _withKeys(onClose, ["esc"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "brief-splash__shapes" }, [
            _createElementVNode("img", {
              src: "//dam.malt.com/rebranding2020/shapes/shapes_malt-plus-splashscreen",
              loading: "lazy",
              alt: ""
            })
          ], -1)),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("header", null, [
                _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$msg('customer.brief.strategy.redirection.splash-screen.howitworks.title')), 1)
              ]),
              _createElementVNode("div", {
                class: "brief-splash__description",
                innerHTML: redirectionDescription.value
              }, null, 8, _hoisted_5),
              (!isMobile.value)
                ? (_openBlock(), _createBlock(_component_VJoyWrapper, {
                    key: 0,
                    justify: "space-between"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_VJoyButton, {
                        variant: "secondary",
                        onClick: backToNewStrategy
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$msg('general.back')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_VJoyButton, {
                        variant: "main",
                        onClick: goToNewBrief
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.strategy.redirection.splash-screen.howitworks.cta')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            (isMobile.value)
              ? (_openBlock(), _createBlock(_component_VJoyWrapper, {
                  key: 0,
                  direction: "column",
                  align: "flex-start",
                  "row-gap": "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VJoyButton, {
                      variant: "main",
                      onClick: goToNewBrief
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$msg('customer.brief.strategy.redirection.splash-screen.howitworks.cta')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_VJoyButton, {
                      variant: "secondary",
                      onClick: backToNewStrategy
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$msg('general.back')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_VJoyButton, {
            circle: "",
            size: "small",
            variant: "white",
            icon: "cross",
            class: "brief-splash__close",
            onClick: onClose
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$msg('general.close')), 1)
            ]),
            _: 1
          })
        ])
      ], 544)
    ]),
    _: 1
  }))
}
}

})